<div class="body" [formGroup]="formGroup">

    <div formArrayName="items" class="content">

        <table mat-table [dataSource]="itemControl.controls|keyvalue" class="table" matSort
            (matSortChange)="sortData($event)">

            <ng-container matColumnDef="position">
                <th mat-header-cell mat-sort-header="itemposition" *matHeaderCellDef>Pos.</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" (click)="ref.focus()">

                    <input formControlName="itemposition" class="input very-tight" matInput #ref type="number" />

                </td>
                <td mat-footer-cell *matFooterCellDef [attr.colspan]="6">
                    {{itemControl.value.length === 0? 'keine Artikel': itemControl.value.length + ' Artikel'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="term">
                <th mat-header-cell mat-sort-header="itemterm" *matHeaderCellDef>Bezeichnung</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" (click)="ref.focus()">

                    <input formControlName="itemterm" class="input medium" matInput #ref />

                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="count">
                <th mat-header-cell mat-sort-header="itemcount" *matHeaderCellDef>Anzahl</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" (click)="ref.focus()">

                    <input formControlName="itemcount" class="input very-tight" matInput #ref type="number" (input)="updateCosts()" />

                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="product">
                <th mat-header-cell mat-sort-header="itemproduct" *matHeaderCellDef>Produkt</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" (click)="ref.focus()">

                    <app-select-product-form formControlName="itemproduct" class="input tight"
                        (productChanged)="itemProductChanged($event, element.value)" matInput #ref>
                    </app-select-product-form>

                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="description">
                <th mat-header-cell mat-sort-header="itemdesc" *matHeaderCellDef>Beschreibung</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" (click)="ref.focus()">

                    <input formControlName="itemdesc" class="input" matInput #ref />

                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="info">
                <th mat-header-cell mat-sort-header="iteminfo" *matHeaderCellDef>Bemerkung</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" (click)="ref.focus()">

                    <input formControlName="iteminfo" class="input" matInput #ref />

                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="setupcost">
                <th mat-header-cell mat-sort-header="itemsetupcost" *matHeaderCellDef>Einrichtung</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" tabindex="0"
                    (focus)="proxyFocus(ref)">

                    <input formControlName="itemsetupcost" class="input tight" matInput #ref=hiddenInput appHiddenInput
                        type="number" (input)="updateSetupCost()" />

                    <label *ngIf="!ref.focussed">
                        {{element.value.controls['itemsetupcost'].value|currency:'EUR':'symbol'}}
                    </label>

                </td>
                <td mat-footer-cell *matFooterCellDef class="currency-footer">
                    {{totalSetupCost|currency:'EUR':'symbol'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="rentalcost">
                <th mat-header-cell mat-sort-header="itemrentalcost" *matHeaderCellDef>Miete</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" tabindex="0"
                    (focus)="proxyFocus(ref)">

                    <input formControlName="itemrentalcost" class="input tight" matInput #ref=hiddenInput appHiddenInput
                        type="number" (input)="updateRentalCost()" />
                    <label *ngIf="!ref.focussed">
                        {{element.value.controls['itemrentalcost'].value|currency:'EUR':'symbol'}}
                    </label>

                </td>
                <td mat-footer-cell *matFooterCellDef class="currency-footer">
                    {{totalRentalCost|currency:'EUR':'symbol'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="purchasecost">
                <th mat-header-cell mat-sort-header="itempurchasecost" *matHeaderCellDef>Kauf</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" tabindex="0"
                    (focus)="proxyFocus(ref)">

                    <input formControlName="itempurchasecost" class="input tight" matInput #ref=hiddenInput
                        appHiddenInput type="number" (input)="updatePurchaseCost()" />

                    <label *ngIf="!ref.focussed">
                        {{element.value.controls['itempurchasecost'].value|currency:'EUR':'symbol'}}
                    </label>

                </td>
                <td mat-footer-cell *matFooterCellDef class="currency-footer">
                    {{totalPurchaseCost|currency:'EUR':'symbol'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="controls">

                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" class="control-cell">

                    <button mat-icon-button color="warn" (click)="removeItem(element.key)">
                        <mat-icon>
                            delete_forever
                        </mat-icon>
                    </button>

                </td>
                <td mat-footer-cell *matFooterCellDef></td>

            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: columns;" class="body-row"></tr>
            <tr mat-footer-row *matFooterRowDef="footerColumns; sticky: true"></tr>

        </table>

    </div>

    <div class="footer">

        <div class="spacer"></div>

        <button mat-raised-button class="control" color="primary" (click)="addArticle()">
            Neuer Artikel
        </button>

        <button mat-raised-button class="control" color="primary" [matMenuTriggerFor]="actionMenu">
            Weitere Aktionen
        </button>

        <div class="spacer"></div>

    </div>

</div>

<mat-menu #actionMenu="matMenu">

    <button mat-menu-item (click)="updateCosts()">
        Kosten berechnen
    </button>

    <button mat-menu-item (click)="normalizePositions()">
        Positionen normalisieren
    </button>

    <button mat-menu-item (click)="removeEmptyItems()">
        Leere Einträge beseitigen
    </button>

</mat-menu>